module.exports = __webpack_public_path__ + "static/media/qiwi.05e69f45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/qiwi.svg
// module id = 887
// module chunks = 7